const routes = {
  all: "*",
  homepage: "/",
  login: "/login",
  dashboard: "/dashboard",
  creation: "/creation",
};

const apiEndpoints = {
  login: "/login",
  logout: "/logout",
};

const notAllowHeader = [];

const notAllowFooter = [routes.creation];

const headerChildPages = [routes.creation];

const companyNames = {
  fog: "fog",
};

const companyConfig = {
  fog_test: {
    name: "fog",
    server: "test",
    checkBrowser: true,
    pages: [
      routes.dmPortal,
      routes.adminPortal,
      routes.adminRestaurantReport,
      routes.adminFTSReport,
      routes.adminAuditorReport,
      routes.adminLabReport,
      routes.dmRestaurantReport,
      routes.dmFTSReport,
      routes.dmAuditorReport,
      routes.dmLabReport,
    ],
  },
  fog_copy: {
    name: "fog",
    server: "copy",
    checkBrowser: true,
    pages: [
      routes.dmPortal,
      routes.adminPortal,
      routes.adminRestaurantReport,
      routes.adminFTSReport,
      routes.adminAuditorReport,
      routes.adminLabReport,
      routes.dmRestaurantReport,
      routes.dmFTSReport,
      routes.dmAuditorReport,
      routes.dmLabReport,
    ],
  },
  fog: {
    name: "fog",
    server: "live",
    checkBrowser: true,
    pages: [
      routes.dmPortal,
      routes.adminPortal,
      routes.adminRestaurantReport,
      routes.adminFTSReport,
      routes.adminAuditorReport,
      routes.adminLabReport,
      routes.dmRestaurantReport,
      routes.dmFTSReport,
      routes.dmAuditorReport,
      routes.dmLabReport,
    ],
  },
};

export {
  routes,
  apiEndpoints,
  notAllowHeader,
  notAllowFooter,
  companyNames,
  companyConfig,
  headerChildPages,
};
